import { createTheme, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import PrimaryColorContext from "./PrimaryColorContext";

const PrimaryColorProvider = ({ children }: { children: JSX.Element }) => {

    const [primaryColor, setPrimaryColor] = useState<any>("#212121");

    // funcao para converter hexadecimal para rgb
    const hexToRgb = (hex: any) =>
        hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
            , (m: any, r: any, g: any, b: any) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map((x: any) => parseInt(x, 16))
    // funcao para converter hexadecimal para rgb    

    // verificar a corno storage
    const checkColor = () => {

        const color = localStorage.getItem("primaryColor");

        if (color) {

            const colorRGB = hexToRgb(color);

            let root = document.documentElement;
            root.style.setProperty('--bs-primary-rgb', colorRGB[0] + ', ' + colorRGB[1] + ', ' + colorRGB[2]);
            setPrimaryColor(color);
        } else {
            let root = document.documentElement;
            root.style.setProperty('--bs-primary-rgb', 33 + ', ' + 33 + ', ' + 33);
            setPrimaryColor("#212121");
        }

    }
    // verificar a corno storage

    const theme = createTheme({
        palette: {
            primary: {
                main: primaryColor
            },
        },
    });

    useEffect(() => {
        checkColor();
    }, [])

    return (
        <PrimaryColorContext.Provider value={{ primaryColor, setPrimaryColor }}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </PrimaryColorContext.Provider>
    )

}

export default PrimaryColorProvider;